import { useEffect } from 'react';
import _ from 'lodash';

import { timeRangeFilterId } from '../../filters';
import { CUSTOM_ID } from '../../filters/time-range-filter/TimeRangeFilterConstants';
import { useFilterState } from '../../../stores/FilterStateStore';
import { useTimeRangeHistory } from '../../../stores/TimeRangeHistoryStore';
import {
    getConstrainedTimerange,
    getMsOf,
    shiftTimerange,
    SHIFT_MULTIPLIER,
    ZOOM_IN_MULTIPLIER,
    ZOOM_OUT_MULTIPLIER,
} from '../../../utilities/TimeRangeNavigationUtilities';

function timeRangeChanged(filterState) {
    const previous = filterState.previous[timeRangeFilterId];
    const current = filterState.current[timeRangeFilterId];

    return previous?.id !== current?.id || (current?.id === CUSTOM_ID && !_.isEqual(previous, current));
}

export default function TimeRangeHistoryProvider({ children }) {
    const [filterState] = useFilterState();
    const [timeRangeHistory, timeRangeHistoryActions] = useTimeRangeHistory();
    useEffect(() => {
        if (!filterState) {
            timeRangeHistoryActions.resetHistory();
        } else if (timeRangeChanged(filterState)) {
            const timeRangeFilterState = filterState.current[timeRangeFilterId];
            const newId = timeRangeFilterState?.id;
            const startMs = getMsOf(timeRangeFilterState.start);
            const endMs = getMsOf(timeRangeFilterState.end);
            const pannedBack = getConstrainedTimerange(
                shiftTimerange(timeRangeFilterState, -SHIFT_MULTIPLIER, -SHIFT_MULTIPLIER),
                { constrainStart: true }
            );
            const pannedForward = getConstrainedTimerange(
                shiftTimerange(timeRangeFilterState, SHIFT_MULTIPLIER, SHIFT_MULTIPLIER),
                { constrainEnd: true }
            );
            const zoomedIn = getConstrainedTimerange(shiftTimerange(timeRangeFilterState, ZOOM_IN_MULTIPLIER, 0), {
                constrainStart: true,
                constrainEnd: true,
                constrainRange: true,
            });
            const zoomedOut = getConstrainedTimerange(shiftTimerange(timeRangeFilterState, ZOOM_OUT_MULTIPLIER, 0), {
                constrainStart: true,
                constrainRange: true,
            });

            timeRangeHistoryActions.setCanPanBack(getMsOf(pannedBack.start) < startMs);
            timeRangeHistoryActions.setCanPanForward(newId === CUSTOM_ID && getMsOf(pannedForward.end) > endMs);
            timeRangeHistoryActions.setCanZoomIn(
                startMs !== getMsOf(zoomedIn.start) || endMs !== getMsOf(zoomedIn.end)
            );
            timeRangeHistoryActions.setCanZoomOut(startMs > getMsOf(zoomedOut.start));

            if (newId && newId !== CUSTOM_ID && _.findIndex(timeRangeHistory.history, { id: newId }) === 0) {
                timeRangeHistoryActions.resetHistory([timeRangeFilterState]);
            } else {
                timeRangeHistoryActions.addHistoryItem(timeRangeFilterState);
            }

            timeRangeHistoryActions.setLastTimeRange(timeRangeFilterState);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterState]);

    return children;
}
